import restDataService from './restDataService';

const ashlinkNextGatewayApiBasePath =
	'api/ashlinknextapigateway/ContentManagement/PostLogin';

const userManagementApiBasePath = 'api/usermanagement';

export const GetFitnessResourcesFn = async (
	drFedId,
	fitnessFileType,
	pageNumber,
	pageSize
) =>
	restDataService
		.get(`${ashlinkNextGatewayApiBasePath}/FitnessResources`, {
			params: {
				DrFedID: drFedId,
				FileType: fitnessFileType,
				Page: pageNumber,
				PageSize: pageSize,
			},
		})
		.catch(error => error.response);

export const UpdateAshlinkChildUserInfo = async params => {
	const response = await restDataService.put(
		`${userManagementApiBasePath}/AshlinkChildUserInfo`,
		params
	);

	return response.data;
};

export const UpdateAshlinkUserTermDate = async params => {
	const response = await restDataService.put(
		`${userManagementApiBasePath}/AshlinkUserTerminationDate`,
		params
	);

	return response.data;
};

export const GetFAQBySpecialtyFn = async drFedId =>
	restDataService
		.get(`${ashlinkNextGatewayApiBasePath}/FitnessFAQBySpecialty`, {
			params: {
				DrFedID: drFedId,
			},
		})
		.catch(error => error.response);

export const GetFitnessPageFn = async (drFedId, pageId) =>
	restDataService
		.get(`${ashlinkNextGatewayApiBasePath}/FitnessPage`, {
			params: {
				DrFedID: drFedId,
				PageID: pageId,
			},
		})
		.catch(error => error.response);

export const GetSessionContext = async () => {
	try {
		return (await restDataService.get('auth/userparams')).data;
	} catch (error) {
		return error;
	}
};

export const GetStatus = async () => {
	try {
		return (await restDataService.get('auth/sessionstatus')).data;
	} catch (error) {
		return error;
	}
};

export const GetFitnessLocationInfoFn = async (apiUrl, apiParams = {}) => {
	const defaultParams = {
		Page: apiParams.page + 1,
		PageSize: apiParams.pageSize,
		SearchString: apiParams.searchString,
	};

	const combinedParams = { ...defaultParams, ...apiParams };
	let response = {};
	if (apiUrl !== '') {
		response = await restDataService.get(
			`${userManagementApiBasePath}/${apiUrl}`,
			{
				params: combinedParams,
			}
		);
	}

	const rows =
		response?.data?.data?.ashlinkUserProfiles ||
		response?.data?.data?.ashlinkUserLocationByEntity ||
		[];

	return {
		data: { rows, ...response?.data?.data },
	};
};

export const GetServiceLocations = async (
	ashlinkUserEntityType,
	ashlinkUserId,
	providerId,
	clinicId,
	searchString,
	page,
	pageSize
) =>
	restDataService.get(`${userManagementApiBasePath}/AshlinkUserProfile`, {
		params: {
			AshlinkUserId: ashlinkUserId,
			AshlinkUserEntityType: ashlinkUserEntityType,
			ProviderId: providerId,
			ClinicId: clinicId,
			SearchString: searchString,
			Page: page,
			PageSize: pageSize,
		},
	});

export const GetAvailableServiceLocations = async (
	ashlinkUserId,
	childAshlinkUserId,
	ashlinkUserEntityType,
	providerId,
	clinicId,
	searchString,
	page,
	pageSize
) =>
	restDataService.get(
		`${userManagementApiBasePath}/AvailableAshlinkUserProfiles`,
		{
			params: {
				ParentAshlinkUserId: ashlinkUserId,
				ParentAshlinkUserEntityType: ashlinkUserEntityType,
				ParentProviderId: providerId,
				ParentClinicId: clinicId,

				ChildAshlinkUserId: childAshlinkUserId,
				ChildAshlinkUserEntityType: ashlinkUserEntityType,
				ChildProviderId: providerId,
				ChildClinicId: clinicId,
				SearchString: searchString,
				Page: page,
				PageSize: pageSize,
			},
		}
	);

export const PutUpdateServiceLocation = async values =>
	restDataService.put(`auth/changelocation`, values);

export const GetSubAccounts = async (
	pageNumber,
	pageSize,
	filter,
	sortField,
	sortDirection
) =>
	restDataService.get(`${userManagementApiBasePath}/AshlinkChildUsers`, {
		params: {
			PageNumber: pageNumber,
			PageSize: pageSize,
			SearchString: filter,
			SortBy: sortField,
			SortDirection: sortDirection,
		},
	});

export const GetPendingSubAccounts = () =>
	restDataService.get(`${userManagementApiBasePath}/PendingAshlinkUsers`);

export const ResendAshlinkUserRegistration = async pendingAshlinkUserId => {
	try {
		return restDataService.put(
			`${userManagementApiBasePath}/ResendPendingAshlinkUserInvitation`,
			{
				PendingAshlinkUserId: pendingAshlinkUserId,
			}
		);
	} catch (error) {
		return error;
	}
};

export const SendPendingAshlinkUserInvitationFn = async (
	pendingAshlinkUserEmail,
	ashlinkUserLevel,
	isTest,
	providerId,
	specialtyCode,
	clinicId,
	drFedIds
) =>
	restDataService
		.post(`${userManagementApiBasePath}/SendPendingAshlinkUserInvitation`, {
			PendingAshlinkUserEmail: pendingAshlinkUserEmail,
			AshlinkUserLevel: ashlinkUserLevel,
			IsTest: isTest,
			ProviderId: providerId,
			SpecialtyCode: specialtyCode,
			ClinicId: clinicId,
			DrFedIds: drFedIds,
		})
		.then(() => pendingAshlinkUserEmail);

export const getIsAuthenticated = async () =>
	restDataService.get('auth/isauthenticated').catch(error => error.response);
